import React from 'react';
import { Button } from 'reactstrap';

const NextBtn = ({
  onClick,
  isDisabled = false,
  label,
  className = '',
}) => {
  return (
    <Button
      block
      color="primary"
      id="create-next-button"
      className={`trato-next-btn ${className}`}
      onClick={onClick}
      disabled={isDisabled}
    >
      {label}
    </Button>
  );
};
const BackBtn = ({
  onClick,
  isDisabled = false,
  label = '',
  className = '',
}) => {
  return (
    <Button
      block
      color="light"
      className={`trato-back-btn ${className}`}
      onClick={onClick}
      disabled={isDisabled}
    >
      {label}
    </Button>
  );
};
export { BackBtn, NextBtn };

export default NextBtn;
